export default "__VITE_ASSET__5b6b4f67__"